exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".specs-type[data-v-17110f52]{color:#FFF;background-color:#1b1b1b;border-radius:5px;padding:5px;line-height:18px}.operate[data-v-17110f52]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.operate .el-button[data-v-17110f52]{margin:3px}.bottomBtn[data-v-17110f52]{height:60px;line-height:70px;background:#ffffff;-webkit-box-shadow:0px -1px 0px 0px #eeeeee;box-shadow:0px -1px 0px 0px #eeeeee;text-align:center;margin-top:50px}\n", ""]);

// exports
